module.exports = __webpack_public_path__ + "static/media/11.35c06c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/11.png
// module id = 1384
// module chunks = 0